export default [
	{
		path: '/task',
		name: 'Task',
		component: () => import('@/views/task/TaskList.vue'),
		meta: {
			layout: 'Default',
			abilities: [['manage', 'tasks']]
		}
	}
]